import React,{useContext} from 'react'
import {Popover,Dropdown,Menu} from 'antd'
import './index.less'
import Context from '../../context/Context'
import {BASE_HOST} from '../../common/config'
import {loginOut} from '../../common/api'

const Index = ()=>{
  const PopoContentMoblie = <div className="page-header-content-menu-pop">
    <i></i>
    <p>扫一扫，手机逛起来</p>
  </div>

  const context = useContext(Context)

  //登陆操作
  const handleLogin = ()=>{
    if(context.isLogin){
      return
    }
    window.location.href = BASE_HOST+'/pa18shopnst/era/order/loginNew/login.shtml?type=01&target=' + encodeURIComponent(window.location.href)
  }
  
  //登出操作
  const handleLogout = ()=>{
    loginOut('').then((res)=>{
      const code=res.data.result_code;
      if(code==="SUCCESS"){
        window.location.href = BASE_HOST+'/pa18shopnst/era/order/loginNew/login.shtml'
      }
    })
    
  }

  const DropdownMenu = (
    <Menu className="page-header-content-menu-user-droplist"> 
      <Menu.Item className="page-header-content-menu-user-droplist-ddgl">
        <a target="_blank" rel="noopener noreferrer" href={`${BASE_HOST}/pa18shopnst/era/order/index.shtml`} style={{color:'#f60'}}>
          订单管理
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href={`${BASE_HOST}/pa18shopnst/era/order/index.shtml`}>
          订单修改
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href={`${BASE_HOST}/pa18shopnst/era/order/index.shtml`}>
          申请理赔
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href={`${BASE_HOST}/baoxianfuwu/index.shtml`}>
          更多服务
        </a>
      </Menu.Item>
      <Menu.Item>
        <div className="page-header-content-menu-user-droplist-yhxb">
          <i></i>
          <a target="_blank" rel="noopener noreferrer" href={`${BASE_HOST}/pa18shopnst/product/non-member/login.html`} style={{color: '#f22'}}>
            优惠续保
          </a>
        </div>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="page-header">
      <div className="page-header-content">
        <a className="page-header-content-logo" href={`${BASE_HOST}/index.shtml`}></a>
        <div className="page-header-content-menu">
          <Popover className="page-header-content-menu-moblie" content={PopoContentMoblie}>
            <i></i>
            <span>手机端</span>
          </Popover>
          <Dropdown  className="page-header-content-menu-user" overlay={DropdownMenu}>
            <span onClick={handleLogin}>{context.isLogin? '我的账户' : '登录'}<i className="page-header-content-menu-user-drop_icon"></i></span>
          </Dropdown>
          { 
            context.isLogin? 
            <span className="page-header-content-menu-register" onClick={handleLogout}>退出</span>
            : <a className="page-header-content-menu-register" target="__blank" href={`${BASE_HOST}/customer/toRegisterUser.do?type=10`}>注册</a>
          }
        </div>
      </div>
    </div>
  )
}

export default Index